import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack, Icon } from '~/components/atomic';

interface ProcessBoxProps {
  type: 'error' | 'success';
  title: string;
  description: string;
}

export default function ProcessBox({
  type,
  title,
  description,
}: ProcessBoxProps) {
  return (
    <Container>
      <IconWrapper sign={type}>
        <Icon iconName={type === 'error' ? 'Alert' : 'Notification'} />
      </IconWrapper>
      <FlexStack spacing={2}>
        <ProcessTitle>{title}</ProcessTitle>
        <ProcessText>{description}</ProcessText>
      </FlexStack>
    </Container>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: 8px 16px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    gap: 8px;
  `}
`;

const IconWrapper = styled.div<{ sign: ProcessBoxProps['type'] }>`
  ${({ theme, sign }) => css`
    color: ${sign === 'error'
      ? theme.themeColor.negative
      : theme.themeColor.main_1};
  `}
`;

const ProcessTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

const ProcessText = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_5};
    ${theme.fontStyle.text.caption_medium};
  `}
`;
